<template>
    <div v-if="markers.length > 0" class="service-status-map">
        <div class="flex justify-end pt-lg md:pt-0">
            <button
                v-if="showMap"
                class="flex items-center"
                @click="showMap = false"
            >
                {{ lang('Dölj karta','Hide map') }}
                <font-awesome-icon icon="eye-slash" class="ml-sm" />
            </button>
            <button
                v-else
                class="flex items-center"
                @click="showMap = true"
            >
                {{ lang('Visa karta','Show map') }}
                <font-awesome-icon icon="eye" class="ml-sm" />
            </button>
        </div>

        <div
            v-show="showMap"
            class="service-status-map-container"
        >
            <div v-if="userErrorWithPosition">
                <div class="flex flex-col items-center justify-center md:flex-row rounded bg-neutral-lighter py-md px-xl mb-lg text-center text-sm">
                    <span>{{ userErrorWithPositionMessage }}</span>
                    <span>&nbsp;{{ lang('För att visa driftstatusar för din position, var god tillåt geopositionering i din webbläsare.','Allow geolocation in your browser to see service statuses at your current position') }}</span>
                </div>
            </div>
            <div v-else-if="! userPositionMarker">
                <div class="bg-neutral-lighter p-md my-lg text-sm text-center">
                    {{ lang('Vi har för tillfället inte din position så vi har centrerat kartan runt aktuella driftstatusar.',"We don't have your current position and have therefore centered the map around current service statuses") }}
                </div>
            </div>

            <base-map
                :zoom="10"
                :markers="markers"
            >
                <service-status-marker
                    v-for="(marker, index) in markers"
                    :key="index"
                    :marker="marker"
                />
                <user-position-marker
                    v-if="userPositionMarker"
                    :marker="userPositionMarker"
                />
            </base-map>
        </div>
    </div>
</template>

<script>
    // For custom marker, see // For custom marker,
    // see https://github.com/xkjyeah/vue-google-maps/issues/38#issuecomment-316245274

    export default {
        props: {
            serviceStatuses: {
                required: true,
                type: Array,
            },
        },
        data() {
            return {
                showMap: true,
                userPositionMarker: null,
                userErrorWithPosition: null,
                userErrorWithPositionMessage: '',
            };
        },
        computed: {
            markers() {
                return this.serviceStatuses
                    .filter(serviceStatus => serviceStatus.lat && serviceStatus.lng)
                    .map(serviceStatus => {
                        return {
                            id: serviceStatus.id,
                            name: serviceStatus.name,
                            count: serviceStatus.count,
                            status: serviceStatus.status,
                            position: {
                                lat: parseFloat(serviceStatus.lat),
                                lng: parseFloat(serviceStatus.lng),
                            },
                        };
                });
            },
        },
        mounted() {
            this.getUserPosition();
        },
        methods: {
            getUserPosition() {
                navigator.geolocation.getCurrentPosition(this.success, this.error, {
                    enableHighAccuracy: true,
                });
            },
            showUserPosition(lat, lng) {
                this.userPositionMarker = {
                    position: {
                        lat: parseFloat(lat),
                        lng: parseFloat(lng),
                    },
                };

                EventBus.$emit('userLocationAcquired', this.userPositionMarker);
            },
            success(position) {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;

                this.showUserPosition(lat, lng);
            },
            error(error) {
                this.userErrorWithPosition = true;

                switch (error.code) {

                    case error.PERMISSION_DENIED:
                        this.userErrorWithPositionMessage = lang('Obs! Du har nekat tillåtelse till din geo-position.','You have denied access to your geolocation.');
                        break;

                    case error.POSITION_UNAVAILABLE:
                        this.userErrorWithPositionMessage = lang('Det gick inte att hitta din nuvarande position','We could not determine your current geolocation');
                        break;

                    case error.TIMEOUT:
                        this.userErrorWithPositionMessage = lang('Det tog för lång tid att hämta din position.','It took too long to find your geolocation.');
                        break;

                    default:
                        this.userErrorWithPositionMessage = lang('Det gick inte att ta del av din position.','We could not determine your current geolocation.');
                        break;
                }
            },
        },
    };
</script>
